import { lookupLocale } from "../locales";
import useLocale from "./useLocale";

export function useRTL(): boolean {
  const locale = useLocale();
  return lookupLocale(locale).dir === "rtl";
}
